export default __webpack_public_path__ + "static/media/j10.496a818c.png";